import React from 'react';
import styled from 'styled-components';
import { Image } from '../../components';
import AgentRoleIcon from '../../assets/images/apply-agent-available.svg';
import ResponsibilitiesIcon from '../../assets/images/rate-call.svg';
import WorkingHoursIcon from '../../assets/images/plans.svg';
import PaymentIcon from '../../assets/images/payment.svg';
import FeedbackIcon from '../../assets/images/human-robot-hands.svg';
import TutorialsIcon from '../../assets/images/monitor-green.svg';
import VideoIcon from '../../assets/images/video.svg';
import DocumentationIcon from '../../assets/images/documentation.svg';
import PdfFile from '../../assets/pdf/Agent_tool_Guidelines.pdf';

import { colors } from '../../utils';

const TextWrapper = styled.div`
  color: ${colors.g04};
  ul {
    padding: 0;
  }

  li {
    margin-bottom: 28px;
  }
`;

const TutorialWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 16px;
`;

const TutorialItem = styled.a`
  align-items: center;
  background: ${colors.g01};
  border-radius: 4px;
  color: ${colors.g04}
  display: flex;
  flex-direction: column;
  max-width: 160px;
  padding: 15px 40px;
  text-align: center;
  text-decoration: none;

  &:visited {
    color: ${colors.g04} !important;
  }

  &:hover {
    background: ${colors.g02};
  }

  span {
    margin-top: -14px;
  }
`;

export default [
  {
    icon: AgentRoleIcon,
    title: 'Agent Role',
    subtitle: 'You take the lead in the job and guide the contributors to complete the task.',
    description: (
      <TextWrapper>
        As an Agent, you will perform jobs to collect new dialogue. The role requires that you
        perform the role of agent in a dialogue collection task within the context of simulated
        customer service and also, guiding, interacting and providing feedback which is critical for
        gathering high-quality data.
      </TextWrapper>
    )
  },
  {
    icon: ResponsibilitiesIcon,
    title: 'Responsibilities',
    subtitle: 'More responsibility in a job will improve your skills and user status on Neevo.',
    description: (
      <TextWrapper>
        <ul>
          <li>
            You will see jobs available on the dashboard (both the environment categories of noisy
            and silent)*.
          </li>
          <li>
            You can work in both environments but always check the balance between online online
            customers and online agents. Before choosing the job you want to tackle, make sure the
            customer respects the environment as well. *Noisy: background noise of life to be
            captured as part of the recording. *Silent: move to a space that will not have sound in
            the background.
          </li>
          <li>
            As part of the role, enter the job and wait for customers to get online. You You do get
            paid for the whole time you spend online so if you don’t get any calls for more than 10
            minutes, log out of the job and return later.
          </li>
          <li>
            As part of the role, enter the job and wait for customers to get online. You do get paid
            for the whole time you spend online so if you don’t get any calls for more than 10
            minutes, log out of the job and return later.
          </li>
          <li>
            We will be spot-checking the recordings you record. If we do notice something wrong, we
            will contact you and guide you how you to improve it.
            <br />- Click on the start recording button (the red one) when you and the customer are
            both both both ready to start the REAL conversation. Otherwise, we don’t need the
            recording.
            <br />- You will be able to find an FAQ at the bottom of the dashboard in the agent’s
            tool. tool. tool. Consult the FAQ should you have any questions or you can contact me
            and I will be happy to help you.
          </li>
        </ul>
      </TextWrapper>
    )
  },
  {
    icon: WorkingHoursIcon,
    title: 'Working Hours',
    subtitle: 'There is some flexibility in the working hours that can work on your benefit.',
    description: (
      <TextWrapper>
        <ul>
          <li>
            There is some flexibility in your hours. We usually open the work for 10-12 hours; so
            you can choose how to manage your time.
          </li>
          <li>
            Please do log out if you don’t receive any calls for more than 10 minutes. We won’t pay
            the additional time spent online without receiving calls.
          </li>
          <li>
            You might get a chance to work over the weekend. If that’s the case, we will notify you
            via email.
          </li>
        </ul>
      </TextWrapper>
    )
  },
  {
    icon: PaymentIcon,
    title: 'Payment',
    subtitle: 'Agents are paid per hour and at a higher rate.',
    description: (
      <TextWrapper>
        You can expect your payment to be sent shortly after the job is completed by all participants.
      </TextWrapper>
    )
  },
  {
    icon: FeedbackIcon,
    title: 'Feedback',
    subtitle:
      'The information you share and collect will be used to improve products on many levels.',
    description: (
      <TextWrapper>
        <ul>
          <li>
            We value your input on the experience of being an Agent at DefinedCrowd. The information
            you share with us will be used to improve the tools you and other Agents use. Please
            give us feedback.
          </li>
          <li>
            Don’t hesitate to contact us. The role you will be performing is very important to the
            success of the dialogue collection projects.
          </li>
        </ul>
      </TextWrapper>
    )
  },
  {
    icon: TutorialsIcon,
    title: 'Tutorials and Guidelines',
    subtitle: 'Videos and other curated information to help you in the role as agent.',
    description: (
      <TextWrapper>
        You will find videos and other documentation that have been curated to guide you on how to
        work as an Agent.
        <TutorialWrapper>
          <TutorialItem
            target="_blank"
            href="https://dcpd01workflowstorage.definedcrowd.com/content/videos/agent_tool_tutorial.mp4"
          >
            <Image with="80px" height="80px" src={VideoIcon} />
            <span>Video Tutorial</span>
          </TutorialItem>
          <TutorialItem href={PdfFile} download target="_self">
            <Image with="80px" height="80px" src={DocumentationIcon} />
            <span>Download Documentation</span>
          </TutorialItem>
        </TutorialWrapper>
      </TextWrapper>
    )
  }
];
